import React from 'react'

type Props = {
  currencies: string[]
  value: string
  onChange: (currency: string) => void
}

const CurrencySelect: React.FC<Props> = ({ currencies, value, onChange }) => {
  if (currencies.length === 0) return null
  return (
    <div className='d-flex align-items-center gap-2'>
      <span className='text-muted fs-8'>Валюта:</span>
      <select
        className='form-select form-select-sm w-auto'
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        {currencies.map((c) => (
          <option key={c} value={c}>
            {c}
          </option>
        ))}
      </select>
    </div>
  )
}

export default CurrencySelect
